import Modal from "@components/atoms/Modal";
import { Spacer, VDBText } from "@components/atoms";
import { Divider } from "@gluestack-ui/themed";
import React, { useState } from "react";
import styled, { useTheme } from "styled-components/native";
import { Image, Linking, Platform } from "react-native";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { SpaceType } from "@components/atoms/Spacer/types";
import { isIpad } from "@utils/design-tokens";
import { useAppSettings, useGlobalScreens } from "@redux/slices/globalSlice";
import { useTranslation } from "react-i18next";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";

const StoreLinksModal = () => {
  const theme = useTheme();
  const getAppSettings = useAppSettings();
  const { faviconUrl } = useOrgSettingsSlice();
  const shouldDisplay =
    (theme.isMobile || isIpad()) &&
    Platform.OS === "web" &&
    !getAppSettings?.hideAppRedirectionModal;
  const [visible, setVisible] = useState(shouldDisplay);
  const { t } = useTranslation();
  const typography = useTypographyStore();
  const globalScreens = useGlobalScreens();
  const loginSettings = globalScreens?.login ?? {};

  const openStore = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    const isAndroid = /android/.test(userAgent);

    if (isIOS) {
      Linking.openURL(loginSettings?.iosStoreUrl ?? "").then();
    } else if (isAndroid) {
      Linking.openURL(loginSettings?.androidStoreUrl ?? "").then();
    }
  };

  return (
    <Modal
      hideHeader={true}
      isOpen={visible}
      onClose={() => setVisible(false)}
      headerTitle={" "}
    >
      <Container onPress={() => openStore()}>
        <Image style={{ width: 72, height: 72 }} source={faviconUrl} />
        <Spacer size={SpaceType.Basic} />
        <VDBText type={typography["H1-B"]} color={theme["core-05"]}>
          {t("global.appRedirection.screenText.text")}
        </VDBText>
        <Spacer size={SpaceType.Double} />
        <OpenButton>
          <VDBIcon
            name={VDBIcons.ARROW_RIGHT}
            size={24}
            color={theme["core-04"]}
            variant={IconsVariant.VDBCustom}
          />
        </OpenButton>
      </Container>
      <Divider />
      <ContinueButton onPress={() => setVisible(false)}>
        <VDBText type={typography["Minor-R"]} color={theme["core-06"]}>
          {t("global.appRedirection.button.text")}
        </VDBText>
      </ContinueButton>
    </Modal>
  );
};

const Container = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  padding: ${SpaceType.Double}px ${SpaceType.Double}px ${SpaceType.Big}px;
`;

const OpenButton = styled.View`
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background-color: ${({ theme }) => theme["core-02"]};
`;

const ContinueButton = styled.TouchableOpacity`
  height: 70px;
  justify-content: center;
  align-items: center;
`;

export default StoreLinksModal;
